
import axios from "axios";
import * as querystring from "querystringify"
import {sm3,sm4} from "sm-crypto";
import SessionStore from "@/utils/SessionStore";
//跨域访问
axios.defaults.withCredentials = true

const SM_KEY = "329sjdkfjasjf933";
const SM_IV = "k23kaskdfj3230dj";

let API_ROOT = "";
let WS_ROOT = "";
let FRONT_ROOT = document.location.href.split("#")[0];
if(process.env.NODE_ENV == 'development') {
    //开发环境
    API_ROOT = FRONT_ROOT+"api";
    WS_ROOT = FRONT_ROOT.replace(/^http/,"ws")+"ws";
}else{
    //生产环境
    API_ROOT = window.globalConfig.prodPath.startsWith("http") ? window.globalConfig.prodPath
        : (window.location.origin+window.globalConfig.prodPath);
    WS_ROOT = API_ROOT.replace(/^http/,"ws");
}

export default {
    data() {
        return {
            loading: false,
            //全局配置
            globalConfig: Object.assign({
                apiRoot: API_ROOT,
                wsRoot: WS_ROOT,
                frontRoot: FRONT_ROOT
            },window.globalConfig),
            //是否移动端
            isMobilePhone: this._testMobilePhone(),
            //移动端样式名，可以加载组件根对象上，可定义.mobile来设置移动端样式
            mobileCss: this._testMobilePhone()?'mobile':''
        }
    },
    methods: {
        /**
         * 发送post请求
         * @param jsJson
         * @param url
         * @param params
         * @param showInfo
         * @returns {boolean}
         */
        post(isJson, url, params, showInfo) {
            return new Promise((resolve, reject) => {
                let p = params;
                if(!isJson) {
                    p = querystring.stringify(params||{});
                }
                axios.post(this.globalConfig.apiRoot+url,p,{
                    headers:{
                    'Content-type': isJson?'application/json;charset=UTF-8':'application/x-www-form-urlencoded;charset=UTF-8'
                    }
                }).then((rep)=>{
                    let dr = rep.data;
                    if(dr.success) {
                        if(showInfo === true && dr.msg){
                            this.$message.success({
                                message: dr.msg,
                                duration: 1500,
                                offset: 60
                            });
                        }
                        resolve(dr);
                    } else if(dr.code == 405){//session失效
                        //创建一个error405的div，用于只显示一次session失效的通知
                        let error405 = document.getElementById("error405");
                        if(error405) {
                            return;
                        }
                        error405 = document.createElement("div");
                        error405.setAttribute("id", "error405");
                        document.body.append(error405);
                        setTimeout(()=>{
                            error405.remove();
                        },200);

                        this.$message.error(dr.msg);
                        this.$router.push({
                            path: "/login",
                            query: this.$route.query
                        });

                    } else {
                        if(showInfo === true){
                            this.$message.error(dr.msg);
                        }
                        reject(dr);
                    }
                }).catch((e)=>{
                    console.error(e);
                    if(showInfo === true){
                        this.$message.error(e.message);
                    }
                    reject({
                        success: false,
                        msg: "请求发生错误：" + e
                    });
                });
            });
        },
        /**
         * 提交form数据到js服务器
         * @param url
         * @param params
         * @param showInfo
         * @returns {boolean}
         */
        postForm(url, params, showInfo)  {
            return this.post(false, url, params, showInfo);
        },
        /**
         * 提交json数据到服务器
         * @param url
         * @param params
         * @param showInfo
         * @returns {boolean}
         */
        postJson(url, params, showInfo)  {
            return this.post(true, url, params, showInfo);
        },
        /**
         * 获取当前登录人
         * @returns {boolean}
         */
        getMe(){
            return this.postForm("/user/me",null, true);
        },
        /**
         * 获取菜单
         */
        getMenus(parentId) {
            return this.postForm("/menu/v2/myMenus",{
                parentId: parentId
            });
        },
        /**
         * 获取代码表
         * @param codeType
         * @param parentCode
         * @returns {boolean}
         */
        getCodes(codeType, parentCode) {
            return this.postForm("/code-item/list", {
                codeType: codeType,
                parentCode: parentCode || null
            }, true);
        },
        //获取第几个字母
        getLetter(index) {
          let letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          return letters.charAt(index);
        },
        //获取中文数字
        getNumberCn(index) {
            let chineseNumbers = ['一','二','三','四','五','六','七','八','九','十'];
            return chineseNumbers[index];
        },
        //获取星期几
        getWeekdayCn(weekday) {
            let chineseNumbers = ['一','二','三','四','五','六','日'];
            return chineseNumbers[weekday-1];
        },
        /**
         * SM3签名
         * @param str
         * @protected
         */
        encryptSm3(str) {
            return sm3(sm3(str)+sm3(SM_IV));
        },
        /**
         * SM4加密
         * @param str
         * @protected
         */
        encryptSm4(str) {
            return sm4.encrypt(str, this.stringToBytes(SM_KEY), {mode: 'cbc', padding:'pkcs#5', iv: this.stringToBytes(SM_IV)})
        },

        stringToBytes(str) {
            let ch, st, re = [];
            for (let i = 0; i < str.length; i++ ) {
                ch = str.charCodeAt(i);  // get char
                st = [];                 // set up "stack"

                do {
                    st.push( ch & 0xFF );  // push byte to stack
                    ch = ch >> 8;          // shift value down by 1 byte
                }

                while ( ch );
                // add stack contents to result
                // done because chars have "wrong" endianness
                re = re.concat( st.reverse() );
            }
            // return an array of bytes
            return re;
        },
        //判断是否移动端
        _testMobilePhone() {
            const ua = navigator.userAgent.toLowerCase();
            const t1 = /phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|opera mini/i.test(
                ua
            );
            return t1 ;
        },

        //组件缓存处理
        setComponentCache(data) {
            SessionStore.setObject("cache_"+this.$route.path, data);
        },
        //清除组件缓存
        clearComponentCache() {
            SessionStore.clear("cache_"+this.$route.path);
        },
        //获取组件缓存
        getComponentCache() {
            return SessionStore.getObjectAndClear("cache_"+this.$route.path);
        }
    }
}
